export var MESSAGE_TYPE;
(function (MESSAGE_TYPE) {
    MESSAGE_TYPE["TEXT"] = "text";
    MESSAGE_TYPE["PO"] = "po";
    MESSAGE_TYPE["PRODUCT_RETAIL"] = "product_retail";
    MESSAGE_TYPE["REPLY"] = "reply";
})(MESSAGE_TYPE || (MESSAGE_TYPE = {}));
